import React from 'react'
import CardFeaturebox1 from './Card-Feature-box1'
// import CardFeaturebox2 from './Card-Feature-box2'
function CardFeature() {
    return (
        <>
            <CardFeaturebox1 />
            {/* <CardFeaturebox2 /> */}
        </>
    )
}

export default CardFeature